import { Button, Container, Row } from "react-bootstrap";
import { Header } from "../../components/UI/Header/Header";
import { Link } from "react-router-dom";

const ScreensAdminCreateAccountCompleted = () => {
  const queryStr = new URLSearchParams(window.location.search);
  const accountID = queryStr.get("id");
  const accountName = queryStr.get("name");

  return (
    // Access.checkAccess(props.appState.userPermissions, Permissions.CodeAdminAccounts, Permissions.TypeCreate, false)
    <Container>
      <Header
        breadcrumbs={[
          { title: "Admin", link: "/caadmin" },
          { title: "Create Account", link: "/caadmin/create" },
          { title: "Completed", link: "/caadmin/create/complete" },
        ]}
        title=""
      />
      <p>Account "{accountName}" created successfully</p>
      <Row>
        {/* This is specifically a href so that it refreshes the page */}
        <Button
          variant="primary"
          href={`/_ccserviceportal/accounts/${accountID}`}
          style={{ marginRight: "0.5rem" }}>
          View Account in Service Portal
        </Button>
        <Button variant="secondary" as={Link} to="/caadmin/create">
          Create another Account
        </Button>
      </Row>
    </Container>
  );
};
export default ScreensAdminCreateAccountCompleted;
